var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isOverdue)?_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-alert")]):_c('span',{staticClass:"grey--text"},[_vm._v("—")])
}
var staticRenderFns = []

export { render, staticRenderFns }